<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WQBo1g/tc-custom/9780062362278.jpg?1724536030895" alt="This image is the cover for the book Disclaimer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Disclaimer
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“<i>Disclaimer</i> is something special. . . an outstandingly clever and twisty tale that’s been perfectly engineered to make heads spin. This novel’s opening promise of menace is not overstated. Ms. Knight lives up to the initial deal she made with readers and delivers fully. . . . That’s a rare payoff in a genre full of letdowns. Its value can’t be stressed enough.” — Janet Maslin, <i>New York Times</i></b></p><p><b>A brilliantly conceived, deeply unsettling psychological thriller about a woman haunted by secrets, the consuming desire for revenge, and the terrible price we pay when we try to hide the truth.</b></p><p>What if you realized the terrifying book you were reading was all about you?</p><p>When a mysterious novel appears at documentary filmmaker Catherine Ravenscroft’s bedside, she is curious. She has no idea who might have sent her <i>The Perfect Stranger</i>—or how it ended up on her nightstand. At first, she is intrigued by the suspenseful story that unfolds. And then she realizes this isn’t fiction. <i>The Perfect Stranger</i> re-creates in vivid, unmistakable detail the day Catherine became hostage to a dark secret, a secret that only one other person knew—and that person is dead.</p><p>Now that the past Catherine so desperately wants to forget is catching up with her, her world is falling apart. Plunged into a living nightmare, her only hope is to confront what really happened on that awful day . . . even if the shocking truth might destroy her.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Renée Knight
      </h2>
      
      <p class="authorDescription body article"><P>Ren&#233;e Knight worked for the BBC directing arts documentaries before turning to writing. She has had TV and film scripts commissioned by the BBC, Channel Four, and Capital Films. In April 2013, she graduated from the Faber Academy &#8220;Writing a Novel&#8221; course, whose alumni include S. J. Watson. She lives in London with her husband and two children.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?114639c8